import { render } from "./personnel.vue?vue&type=template&id=20b7a5bd"
import script from "./personnel.vue?vue&type=script&lang=js"
export * from "./personnel.vue?vue&type=script&lang=js"

import "./personnel.vue?vue&type=style&index=0&id=20b7a5bd&lang=less"

import exportComponent from "/root/workspace/service-web_SY5C/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__